import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { PageLoader } from '../components/PageLoader';

export default function AuthRoot() {
  const Component = withAuthenticationRequired(
    () => {
      return <Outlet />;
    },
    {
      onRedirecting: () => (
        <div className="page-layout">
          <PageLoader />
        </div>
      ),
      loginOptions: {
        appState: { returnTo: window.location.pathname + window.location.search + window.location.hash },
      },
    }
  );

  return <Component />;
}
